import { render, staticRenderFns } from "./XmPagel.vue?vue&type=template&id=8a075210&scoped=true"
import script from "./XmPagel.vue?vue&type=script&lang=js"
export * from "./XmPagel.vue?vue&type=script&lang=js"
import style0 from "./XmPagel.vue?vue&type=style&index=0&id=8a075210&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a075210",
  null
  
)

export default component.exports